class Flooding implements ng.IDirective {
    transclude = true;
    restrict = 'E';
    scope = {
        info: "="
    };
    template = require('./template.flooding.html');
    public controller = 'floodingController';
    public controllerAs = 'vm';
    public bindToController = true;

    constructor() { };

    public static Factory() {
        var directive = () => {
            return new Flooding();
        }
        return directive;
    }
}

export default Flooding;



// WEBPACK FOOTER //
// ./src/app/flooding/directive.flooding.ts